module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-10.fd3de119.svg";